<template>
  <div style = "margin-left:20px">
    <HeaderPage />
    <div style="display: flex;">
      <el-button style = "margin-top:20px;background:#0049c8;color:#ffffff;display:inline-block;width:140px;margin-left:60px;margin-right: auto;">测量&均衡显示</el-button>
      <el-button style = "margin-top:20px;background:#0049c8;color:#ffffff;display:inline-block;width:100px;margin-right:100px;margin-left:auto">脉冲显示</el-button>
      <el-button style = "margin-top:20px;background:#0049c8;color:#ffffff;display:inline-block;width:100px;margin-right: 60px;">诊断报告</el-button>
    </div>
    <div style="display: flex;">
      <!-- <ShowMoreLine :list-data="listData1" style="position:absolute;top:70px;height:500px"/> -->
    <!-- <div style="position:absolute;top:10px;left:25px;z-index:99;"> -->
    <div style="display: inline-block;margin-top: 50px;margin-left: 30px;">
      <div style="display: flex;margin-bottom: 10px;">
        <span style="margin-left: 20p;margin-right: auto;font-size: 15px;font-weight: bold;">离散度</span>
        <span style="margin-left: 100px;margin-right: auto;font-size: 15px;font-weight: bold;">状态：充电中</span>
      </div>
      <div style="display: flex;">
        <div style="margin-left: 10px;margin-right: 70px;line-height: 120px;">>3</div>
        <LineDraw :list-data="listData"/>
      </div>
      <div style="display: flex;">
        <div style="line-height: 120px;margin-left: 10px;margin-right: 70px;">2-3</div>
        <LineDraw :list-data="listData1"/>
      </div>
      <div style="display: flex;">
        <div style="line-height: 120px;margin-left: 10px;margin-right: 70px;">1-2</div>
      <LineDraw :list-data="listData3"/>
    </div>
      <div style="display: flex;">
        <div style="line-height: 120px;margin-left: 10px;margin-right: 70px;">0-1</div>
      <LineDraw :list-data="listData3"/>
    </div>
      <!-- <LineDraw :style="{position:'absolute',top:listData3.length<9?'510px':'462px'}" :list-data="listData3"/> -->
    </div>
    <!-- <div id = "main" style="position:absolute;width:800px;height: 600px;top:100px;left:0;z-index: -1;"></div> -->
    <div id = "master" style="width:800px;height: 550px;z-index: 999;display: inline-block;margin-left: 150px;margin-top: 100px;"></div>
  </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import HeaderPage from './HeaderPage.vue';
// import SymbolView from './Utils/SymbolView.vue';
// import ShowMoreLine from './Utils/ShowMoreLine.vue'
import LineDraw from './Utils/LineDraw.vue';
export default {
 name: 'BattertBalance',
 components:{
  // SymbolView,
  LineDraw,
  HeaderPage,
  // ShowMoreLine
 },
 data () {
  return {
    'listData':[{
                id:1,
                text:3100,
                show:true,
                'chargeStatus':'charge',
            },
            {
                id:2,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            {
                id:3,
                text:3300,
                show:true,
                'chargeStatus':'',
            },
            {
                id:4,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            }
      ],
    'listData1':[{
                id:1,
                text:3100,
                show:true,
                'chargeStatus':'charge',
            },
            {
                id:2,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            {
                id:3,
                text:3300,
                show:true,
                'chargeStatus':'',
            },
            {
                id:4,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            {
                id:1,
                text:3100,
                show:true,
                'chargeStatus':'charge',
            },
            {
                id:2,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            ],
    'listData2':[{
                id:1,
                text:3100,
                show:true,
                'chargeStatus':'charge',
            },
            {
                id:2,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            {
                id:3,
                text:3300,
                show:true,
                'chargeStatus':'',
            },
            {
                id:4,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            },
            {
                id:1,
                text:3100,
                show:true,
                'chargeStatus':'charge',
            },
            {
                id:2,
                text:3200,
                show:true,
                'chargeStatus':'discharge',
            }],
    'listData3':[
    {
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },{
        id:1,
        text:3100,
        show:true,
        'chargeStatus':'charge',
    },
    {
        id:2,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:1,
        text:3100,
        show:true,
        'chargeStatus':'charge',
    },
    {
        id:2,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },{
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:1,
        text:3100,
        show:true,
        'chargeStatus':'charge',
    },
    {
        id:2,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    },
    {
        id:3,
        text:3300,
        show:true,
        'chargeStatus':'',
    },
    {
        id:4,
        text:3200,
        show:true,
        'chargeStatus':'discharge',
    }
    ],
   msg: 'Welcome to Your Vue.js App',
   dataShowFirstLine:[{
    id:1,
    text:3200,
    show:true,
    chargeStatus:'charge'
   },
   {
    id:2,
    text:3200,
    show:true,
    chargeStatus:'discharge'
   },
   {
    id:3,
    text:3200,
    show:true,
    charge:''
   },
   {
    id:4,
    text:3200,
    show:true,
    chargeSatus:''
   }]
  }
 },
 mounted(){
  // this.drawChart();
  this.draw();
 },
 methods: {
  draw(){
    var chartDom = document.getElementById('master');
    var myChart = echarts.init(chartDom);
    var option;

option = {
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine','Value','type','1','2','3','4','5','6','7','8','11','12','13','14','15','16','17','18'],
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
      "axisTick":{
        "show":false
      },
      axisLine:{
        lineStyle:{
          color:'#5b9bd5',
        },
        symbol: ['none','arrow'],
      },
      data: ['', '', '', '', '', '', '']
  },
  yAxis: {
      show:true,
      type: 'value',
      "axisTick":{
        "show":false
      },
      axisLine:{
            show:true,
            lineStyle:{
              color:'#5b9bd5',
            },
            symbol: ['none','arrow'],
          },
      axisLabel: {  
        showMaxLabel: false,
      }              
  },
  series: [{
      name: '1',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '2',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '3',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '4',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '5',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '6',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '7',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '8',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '11',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '12',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '13',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '14',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '15',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '16',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '17',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: '18',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: 'Value',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },{
      name: 'Value',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: 'Email',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: 'Union Ads',
      type: 'line',
      stack: 'Total',
      data: [220, 182, 191, 234, 290, 330, 310]
    },
    {
      name: 'Video Ads',
      type: 'line',
      stack: 'Total',
      data: [150, 232, 201, 154, 190, 330, 410]
    },
    {
      name: 'Direct',
      type: 'line',
      stack: 'Total',
      data: [320, 332, 301, 334, 390, 330, 320]
    },
    {
      name: 'Search Engine',
      type: 'line',
      stack: 'Total',
      data: [820, 932, 901, 934, 1290, 1330, 1320]
    }
  ]
};

option && myChart.setOption(option);
  },
  drawChart() {
    var chartDom = document.getElementById('main');
    var myChart = echarts.init(chartDom);
    var option;

    option = {
    xAxis: {
      type: 'category',
      "axisTick":{
        "show":false
      },
      axisLine:{
        lineStyle:{
          color:'#5b9bd5',
        },
        symbol: ['none','arrow'],
      },
      data: ['', '', '', '', '', '', '']
    },
    yAxis: {
              show:true,
              // data:['0','1','2','3'],
              min:0,
              max:4,
              space:1,
              splitLine:false,
              type: 'value',
              "axisTick":{
                "show":false
              },
              axisLine:{
                    show:true,
                    lineStyle:{
                      color:'#5b9bd5',
                    },
                    symbol: ['none','arrow'],
                  },
              axisLabel: {  
                showMaxLabel: false,
              }
                  
              // 
            },
        };
      option && myChart.setOption(option);
    },
  }
}
  </script>
  <style>
  </style>
